import styled from "styled-components";

const Wrapper = styled.input`
  &.typeing-input {
    width: 100%;
    height: 32px;
    font-family: var(--roboto-font);
    font-size: 20px;
    border: none;
    border-bottom: 1px solid var(--eb-5A5A5A);
    color: var(--eb-5A5A5A);
    padding-left: 8px;
    margin-bottom: 33px;
  }
  margin-bottom: 15px;
  outline: none;
`;

export default Wrapper;
